import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import Moment from 'moment'

import TextField from 'material-ui/TextField'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker'

import InputLongInt from 'components/InputLongInt'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import Section from 'components/Section'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	})
)

export class Facts extends Component{
	render(){
		let { props } = this
		let propertyID = props.propertyID
		return(
			<Section id="property/facts" title="Facts">
						<div style={{width: "auto"}}>
							<table
								style={{marginLeft: "0px"}}
							>
								<tbody>
									<tr>
										<td>Built year:</td>
										<td><TextField
											defaultValue={props.property.builtYear}
											type="Number"
											key={props.property.builtYear}
											style={{
												width: "100%",
												marginLeft: "10px"
											}}
											onBlur={(evt) =>{
												props.STAGE({
													_id: propertyID
													, builtYear: evt.target.value
												})
											}}
										/></td>
									</tr>
									<tr>
										<td>Cooling type:</td>
										<td><TextField
											defaultValue={props.property.cooling}
											key={props.property.cooling}
											style={{
												width: "100%",
												marginLeft: "10px"
											}}

											onBlur={(evt) =>{
												props.STAGE({
													_id: propertyID
													, cooling: evt.target.value
												})
											}}
										/></td>
									</tr>
									<tr>
										<td>Heating type:</td>
										<td><TextField
											defaultValue={props.property.heating}
											key={props.property.heating}
											style={{
												width: "100%",
												marginLeft: "10px"
											}}
											onBlur={(evt) =>{
												props.STAGE({
													_id: propertyID
													, heating: evt.target.value
												})
											}}
										/></td>
									</tr>
									<tr>
										<td>Sq. footage:</td>
										<td><InputLongInt
											value={props.property.sqFootage}
											key={props.property.sqFootage}
											style={{
												width: "100%",
												marginLeft: "10px"
											}}
											onBlur={(value) =>{
												props.STAGE({
													_id: propertyID
													, sqFootage: value
												})
											}}
										/></td>
									</tr>
									<tr>
										<td>Parking:</td>
										<td>
											<SelectField
												key={props.property.parking}
												style={{marginLeft: "10px", width: "100%", height:"40px"}}
												labelStyle={{fontSize: "16",  color: "#000"}}
												value={props.property.parking}
												onChange={(evt, indx, value) =>{
													props.STAGE({
														_id: propertyID
														, parking: value
													})
												}}
											>
												<MenuItem key={0} value={"None"} primaryText="None" />
												<MenuItem key={1} value={"On-Street Parking"} primaryText="On-Street Parking" />
												<MenuItem key={2} value={"Off Street Parking"} primaryText="Off Street Parking" />
												<MenuItem key={3} value={"Carports"} primaryText="Carports" />
												<MenuItem key={4} value={"Detached Garage"} primaryText="Detached Garage" />
												<MenuItem key={5} value={"Attached Garage"} primaryText="Attached Garage" />
											</SelectField>
										</td>
									</tr>
									<tr>
										<td>Beds:</td>
										<td><TextField

											type = "number"
											defaultValue={props.property.beds}
											key={props.property.beds}
											inputStyle={{fontSize: "16",  color: "#000"}}
											style={{
												width: "100%",
												marginLeft: "10px",
												verticalAlign: "center"
											}}
											onBlur={(evt) =>{
												props.STAGE({
													_id: propertyID
													, beds: evt.target.value
												})
											}}
										/></td>
									</tr>
									<tr>
										<td>Baths:</td>
										<td><TextField
											type = "number"
											defaultValue={props.property.baths}
											key={props.property.baths}
											inputStyle={{fontSize: "16",  color: "#000"}}
											style={{
												width: "100%",
												marginLeft: "10px"
											}}
											onBlur={(evt) =>{
												props.STAGE({
													_id: propertyID
													, baths: evt.target.value
												})
											}}

										/></td>
									</tr>
									<tr>
										<td>Use code:</td>
										<td><TextField

											defaultValue={props.property.useCode}
											key={props.property.useCode}
											inputStyle={{fontSize: "16",  color: "#000"}}
											style={{
												width: "100%",
												marginLeft: "10px"
											}}
											onBlur={(evt) =>{
												props.STAGE({
													_id: propertyID
													, useCode: evt.target.value
												})
											}}

										/></td>
									</tr>
									<tr>
										<td>Levels:</td>
										<td><TextField

											defaultValue={props.property.levels}
											key={props.property.levels}
											inputStyle={{fontSize: "16",  color: "#000"}}
											style={{
												width: "100%",
												marginLeft: "10px"
											}}
											onBlur={(evt) =>{
												props.STAGE({
													_id: propertyID
													, levels: evt.target.value
												})
											}}

										/></td>
									</tr>
									<tr>
										<td>Appliances:</td>
										<td><TextField
												defaultValue={props.property.note}
												key={props.property.note}
												multiLine={true}
											inputStyle={{fontSize: "16",  color: "#000"}}
											style={{
												width: "100%",
												marginLeft: "10px"
											}}
												onBlur={(evt)=>{
															props.STAGE({
																	_id: propertyID
																, note: evt.target.value
															})
												}}
										/></td>
									</tr>
									<tr>
										<td>Full price:</td>
										<td><InputLongInt
											value={props.property.price}
											key={props.property.price}
											style={{
												width: "100%",
												marginLeft: "10px"
											}}
											onBlur={(value) =>{
												props.STAGE({
													_id: propertyID
													, price: value
												})
											}}
										/></td>
									</tr>
								</tbody>
							</table>
						</div>
					</Section>
		)
	}
}

export default connect(select, dataActions)(Facts)



// WEBPACK FOOTER //
// ./src/routes/landlord/propertyForm/Facts.js